<template>
    <div class="login-container">
        <form class="vue-form" @submit.prevent="handleLogin">
            <h2 class="subtitle-form">Bienvenido</h2>
            <h1 class="title-form">Inicia Sesión</h1>
            <div class="description">
                <div>
                    <label class="label" for="email">Correo</label>
                    <input type="email" id="email" v-model="email" placeholder="Ingresa tu correo" required />
                </div>
                <div>
                    <label class="label" for="password">Contraseña</label>
                    <input type="password" id="password" placeholder="Ingresa tu contraseña" v-model="password"
                        required />
                </div>
                <div>
                    <input type="submit" value="Iniciar" />
                    <p v-if="error">{{ error }}</p>
                </div>
            </div>
        </form>
        <div class="vue-image-right">
            <img src="../assets/Home.gif" alt="imagen de referencia">
        </div>
        <img class="floating-logo" src="../assets/LogoCircle.png" alt="imagen logo fmce" />
    </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

export default {
    setup() {
        const email = ref('');
        const password = ref('');
        const error = ref(null);
        const authStore = useAuthStore();
        const router = useRouter();

        const handleLogin = async () => {
            try {
                await authStore.login(email.value, password.value, router);
            } catch (err) {
                error.value = 'Error en el inicio de sesión.';
            }
        };

        return { email, password, handleLogin, error };
    }
};
</script>

<style src="../styles/login.css" scoped></style>